(function () {
  'use strict';

  const config = window.StockOpsFamilyStockConfig || {};
  const connectionId = String(config.connectionId || '').trim();
  const endpoint = 'https://base44.app/api/apps/69990348b71f799bdd79f9fd/functions/validateShopifyFamilyCart';
  const headers = {
    'Content-Type': 'application/json',
    'X-App-Id': '69990348b71f799bdd79f9fd',
    'Base44-Functions-Version': 'preview'
  };
  const variantSkuCache = new Map();

  function stripTierSuffix(sku) {
    return String(sku || '').trim().replace(/\(\d+\)$/i, '');
  }

  function mayUseSharedFamily(lines) {
    return (lines || []).some((line) => /_\d+$/i.test(stripTierSuffix(line && line.sku)));
  }

  async function cartLines() {
    const response = await fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    });
    if (!response.ok) throw new Error('Could not read the cart');
    const cart = await response.json();
    return (cart.items || []).map((item) => ({
      sku: String(item.sku || ''),
      quantity: Math.max(0, Number(item.quantity || 0))
    }));
  }

  async function variantSku(variantId) {
    const key = String(variantId || '').trim();
    if (!key) throw new Error('Variant ID missing');
    if (variantSkuCache.has(key)) return variantSkuCache.get(key);

    const response = await fetch('/variants/' + encodeURIComponent(key) + '.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    });
    if (!response.ok) throw new Error('Could not identify the selected product');
    const variant = await response.json();
    const sku = String(variant.sku || '');
    variantSkuCache.set(key, sku);
    return sku;
  }

  async function validateLines(lines) {
    const normalized = (lines || [])
      .map((line) => ({
        sku: String(line && line.sku || '').trim(),
        quantity: Math.max(0, Math.floor(Number(line && line.quantity || 0)))
      }))
      .filter((line) => line.sku && line.quantity > 0);

    if (!connectionId || !mayUseSharedFamily(normalized)) {
      return { valid: true, managed: false, skipped: true, message: '' };
    }

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-store',
        headers,
        body: JSON.stringify({ connection_id: connectionId, lines: normalized })
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) {
        return {
          valid: false,
          managed: true,
          message: result.message || result.error || 'Unable to verify shared family stock right now. Please try again.'
        };
      }
      return result;
    } catch (error) {
      console.error('[StockOpsFamilyStock] validation failed', error);
      return {
        valid: false,
        managed: true,
        message: 'Unable to verify shared family stock right now. Please try again.'
      };
    }
  }

  async function validateChange(lineIndex, requestedQuantity) {
    try {
      const lines = await cartLines();
      const index = Number(lineIndex) - 1;
      if (index < 0 || index >= lines.length) return { valid: true, managed: false, skipped: true, message: '' };

      const quantity = Math.max(0, Math.floor(Number(requestedQuantity || 0)));
      if (quantity === 0) {
        lines.splice(index, 1);
      } else {
        lines[index] = { ...lines[index], quantity };
      }
      return await validateLines(lines);
    } catch (error) {
      console.error('[StockOpsFamilyStock] cart-change preflight failed', error);
      return {
        valid: false,
        managed: true,
        message: 'Unable to verify shared family stock right now. Please try again.'
      };
    }
  }

  async function validateAdd(variantId, requestedQuantity) {
    try {
      const quantity = Math.max(1, Math.floor(Number(requestedQuantity || 1)));
      const [lines, sku] = await Promise.all([cartLines(), variantSku(variantId)]);
      lines.push({ sku, quantity });
      return await validateLines(lines);
    } catch (error) {
      console.error('[StockOpsFamilyStock] add preflight failed', error);
      return {
        valid: false,
        managed: true,
        message: 'Unable to verify shared family stock right now. Please try again.'
      };
    }
  }

  async function validateCart() {
    try {
      return await validateLines(await cartLines());
    } catch (error) {
      console.error('[StockOpsFamilyStock] checkout preflight failed', error);
      return {
        valid: false,
        managed: true,
        message: 'Unable to verify shared family stock right now. Please try again.'
      };
    }
  }

  function showCartError(message) {
    const text = String(message || 'The requested quantity is not available.');
    document.querySelectorAll('[data-stockops-family-stock-error]').forEach((node) => node.remove());

    const containers = [
      document.querySelector('cart-drawer .cart__ctas'),
      document.querySelector('#main-cart-footer .cart__ctas'),
      document.querySelector('.cart__footer .cart__ctas')
    ].filter(Boolean);

    const container = containers[0];
    if (!container) {
      window.alert(text);
      return;
    }

    const error = document.createElement('div');
    error.setAttribute('data-stockops-family-stock-error', '');
    error.setAttribute('role', 'alert');
    error.style.cssText = 'width:100%;margin:0 0 10px;padding:10px 12px;border:1px solid #c62828;border-radius:6px;background:#fff4f4;color:#9d1717;font-size:13px;line-height:1.35;';
    error.textContent = text;
    container.parentNode.insertBefore(error, container);
    error.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  function nativeCheckout(form) {
    if (!form) return;
    let hidden = form.querySelector('input[data-stockops-checkout-bypass]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'checkout';
      hidden.value = 'Checkout';
      hidden.setAttribute('data-stockops-checkout-bypass', '');
      form.appendChild(hidden);
    }
    HTMLFormElement.prototype.submit.call(form);
  }

  document.addEventListener('click', async (event) => {
    const target = event.target && event.target.closest
      ? event.target.closest('[name="checkout"], a[href*="/checkout"]')
      : null;
    if (!target || target.hasAttribute('data-stockops-family-stock-bypass')) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const wasDisabled = 'disabled' in target ? target.disabled : false;
    if ('disabled' in target) target.disabled = true;

    let lines;
    try {
      lines = await cartLines();
    } catch (error) {
      if ('disabled' in target) target.disabled = wasDisabled;
      showCartError('Unable to verify stock right now. Please try again.');
      return;
    }

    if (!mayUseSharedFamily(lines)) {
      target.setAttribute('data-stockops-family-stock-bypass', '');
      if (target.tagName === 'A') {
        window.location.assign(target.href);
        return;
      }
      nativeCheckout(target.form || target.closest('form'));
      return;
    }

    const validation = await validateLines(lines);
    if (!validation || validation.valid === false) {
      if ('disabled' in target) target.disabled = wasDisabled;
      showCartError(validation && validation.message);
      return;
    }

    target.setAttribute('data-stockops-family-stock-bypass', '');
    if (target.tagName === 'A') {
      window.location.assign(target.href);
      return;
    }
    nativeCheckout(target.form || target.closest('form'));
  }, true);

  window.StockOpsFamilyStock = {
    cartLines,
    validateLines,
    validateChange,
    validateAdd,
    validateCart,
    showCartError,
    mayUseSharedFamily
  };
})();
